export default __webpack_public_path__ + "static/media/back_1.a6609b48.jpg";